export enum SessionType {
    buy = "Achat",
    sell = "Vente",
};